import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { ResumeData } from '../../../../../types/resume';
import { generatePDF } from '../../../../../utils/pdf';
import { trackEvent } from '../../../../../lib/analytics/tracking';
import { resumeEvents } from '../../../../../lib/analytics/events';

interface Props {
  data: ResumeData;
}

export default function ActionButtons({ data }: Props) {
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleDownload = async () => {
    try {
      setDownloading(true);
      setError(null);
      setError(null);
      
      // Generate filename with timestamp
      const timestamp = new Date().toISOString().split('T')[0];
      const safeName = (data.personalInfo?.fullName || 'resume')
        .toLowerCase()
        .replace(/[^a-z0-9]/g, '_');
      const filename = `${safeName}_${timestamp}.pdf`;

      // Generate editable PDF
      // Generate PDF
      await generatePDF(data, filename);
      
      // Track successful download
      trackEvent(resumeEvents.downloadResume('pdf'));
      
      // Track successful download
      trackEvent(resumeEvents.downloadResume('pdf'));
    } catch (err) {
      console.error('Error downloading resume:', err);
      setError('Failed to download resume. Please try again.');
      setError('Failed to download resume. Please try again.');
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="space-y-4">
      <button
        onClick={handleDownload}
        disabled={downloading}
        className="w-full flex items-center justify-center gap-2 px-4 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        <Download className="h-5 w-5" />
        {downloading ? 'Generating PDF...' : 'Download PDF'}
      </button>

      {error && (
        <p className="text-sm text-red-600 text-center mt-2">{error}</p>
      )}

      <p className="text-xs text-gray-500 text-center mt-4">
        Your resume will be downloaded as a PDF file. No data is stored on our servers.
      </p>

      {error && (
        <p className="text-sm text-red-600 text-center">{error}</p>
      )}

      <p className="text-xs text-gray-500 text-center">
        Your resume will be downloaded as an editable PDF file with searchable text.
        No data is stored on our servers.
      </p>
    </div>
  );
}